<template>
  <base-modal
    id="outreach_detail_modal"
    :show="show"
    size="modal-xl"
    :show-close-button="true"
    @closed="onClosed"
  >
    <div class="container">
      <base-heading class="pb-2 clientName">
        {{ clientName }}
      </base-heading>
      <hr
        class="mb-4"
        style="border-color: #d4d4d4; margin-top: unset !important;"
      >
      <!-- <hr class="divider mt-n2 pb-2"> -->
      <base-text v-html="editSubject" />
      <base-text
        class="date pb-2"
        muted
      >
        Sent {{ sentDate | nicedate }}
      </base-text>
      <base-loading
        v-if="loading"
        :show="true"
        class="mt-4"
      />
      <table
        v-else
        class="mt-4"
        cellpadding="0"
      >
        <tbody>
          <tr
            v-for="(item, index) in events"
            :key="`item_${index}`"
          >
            <td>
              <base-text
                class="text-uppercase date spaced"
                nowrap
              >
                {{ item.date | nicedate('custom', 'M/DD/YY') }}&nbsp;&nbsp;&nbsp;{{ item.date |
                  nicedate('xsmall') }}&nbsp;
              </base-text>
            </td>
            <td>
              <base-text
                light
                muted
                class="text-capitalize ml-2 mr-3"
                size="md"
              >
                {{ map_event(item.event) }}
              </base-text>
            </td>
            <td>
              <a
                v-if="item.url"
                :href="item.url"
              >
                <base-text
                  size="md"
                  light
                  trim
                  max-width="580"
                  class="text-underlined black"
                >{{ item.url }}</base-text>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </base-modal>
</template>
<script>
export default {

  name: 'ClientEmailEventsModal',
  inheritAttrs: false,
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    editSubject: {
      type: String,
      default: '',
    },
    clientName: {
      type: String,
      default: '',
    },
    sentDate: {
      type: String,
      required: true,
    },
    events: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      key: Date.now(),
    };
  },
  methods: {
    onClosed() {
      this.$emit('closed');
    },
    map_event(event_name) {
      const mp = {
        delivered: 'Sent',
        unsubscribe_click: 'Unsubscribe',
      };

      return mp[event_name] || event_name;
    },
  },
};
</script>
<style lang="scss"
  scoped>
.container {
  padding: calc(48px - 1rem) calc(56px - 1rem);
}

.date {
  font-size: 11px;
  color: $gray-light-2 !important;

  &.spaced {
    letter-spacing: 0.7772px;
  }
}

::v-deep .modal-dialog {
  max-width: 940px;
}

.clientName {
  font-size: 22px;
  line-height: 24px;
  font-weight: 600;
  font-family: 'Tiempos';
  font-style: normal;
}

table {
  border-spacing: 0;

  & tbody {
    & tr {
      padding: 0;

      & td {
        & a {
          margin: 0 !important;
        }
      }
    }
  }
}

.black {
  color: $black;
}
</style>
